// Curated list of ~60 countries — Africa-first (since StaffLink Ghana's core
// market) then major global markets. Each entry has ISO code, name, dial
// prefix (no plus) and flag emoji so we can render nicely without a font.

export const countries = [
  // West Africa (StaffLink's home region)
  { code: "GH", name: "Ghana", dial: "233", flag: "🇬🇭" },
  { code: "NG", name: "Nigeria", dial: "234", flag: "🇳🇬" },
  { code: "CI", name: "Côte d'Ivoire", dial: "225", flag: "🇨🇮" },
  { code: "SN", name: "Senegal", dial: "221", flag: "🇸🇳" },
  { code: "TG", name: "Togo", dial: "228", flag: "🇹🇬" },
  { code: "BJ", name: "Benin", dial: "229", flag: "🇧🇯" },
  { code: "BF", name: "Burkina Faso", dial: "226", flag: "🇧🇫" },
  { code: "ML", name: "Mali", dial: "223", flag: "🇲🇱" },
  { code: "LR", name: "Liberia", dial: "231", flag: "🇱🇷" },
  { code: "SL", name: "Sierra Leone", dial: "232", flag: "🇸🇱" },
  { code: "GM", name: "Gambia", dial: "220", flag: "🇬🇲" },
  { code: "GN", name: "Guinea", dial: "224", flag: "🇬🇳" },

  // East & Southern Africa
  { code: "KE", name: "Kenya", dial: "254", flag: "🇰🇪" },
  { code: "UG", name: "Uganda", dial: "256", flag: "🇺🇬" },
  { code: "TZ", name: "Tanzania", dial: "255", flag: "🇹🇿" },
  { code: "RW", name: "Rwanda", dial: "250", flag: "🇷🇼" },
  { code: "ET", name: "Ethiopia", dial: "251", flag: "🇪🇹" },
  { code: "ZA", name: "South Africa", dial: "27", flag: "🇿🇦" },
  { code: "BW", name: "Botswana", dial: "267", flag: "🇧🇼" },
  { code: "NA", name: "Namibia", dial: "264", flag: "🇳🇦" },
  { code: "ZM", name: "Zambia", dial: "260", flag: "🇿🇲" },
  { code: "ZW", name: "Zimbabwe", dial: "263", flag: "🇿🇼" },
  { code: "MZ", name: "Mozambique", dial: "258", flag: "🇲🇿" },
  { code: "MW", name: "Malawi", dial: "265", flag: "🇲🇼" },
  { code: "AO", name: "Angola", dial: "244", flag: "🇦🇴" },
  { code: "CM", name: "Cameroon", dial: "237", flag: "🇨🇲" },
  { code: "CD", name: "DR Congo", dial: "243", flag: "🇨🇩" },

  // North Africa & Middle East
  { code: "EG", name: "Egypt", dial: "20", flag: "🇪🇬" },
  { code: "MA", name: "Morocco", dial: "212", flag: "🇲🇦" },
  { code: "DZ", name: "Algeria", dial: "213", flag: "🇩🇿" },
  { code: "TN", name: "Tunisia", dial: "216", flag: "🇹🇳" },
  { code: "AE", name: "United Arab Emirates", dial: "971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial: "966", flag: "🇸🇦" },
  { code: "QA", name: "Qatar", dial: "974", flag: "🇶🇦" },
  { code: "IL", name: "Israel", dial: "972", flag: "🇮🇱" },
  { code: "TR", name: "Turkey", dial: "90", flag: "🇹🇷" },

  // Europe
  { code: "GB", name: "United Kingdom", dial: "44", flag: "🇬🇧" },
  { code: "IE", name: "Ireland", dial: "353", flag: "🇮🇪" },
  { code: "FR", name: "France", dial: "33", flag: "🇫🇷" },
  { code: "DE", name: "Germany", dial: "49", flag: "🇩🇪" },
  { code: "ES", name: "Spain", dial: "34", flag: "🇪🇸" },
  { code: "IT", name: "Italy", dial: "39", flag: "🇮🇹" },
  { code: "NL", name: "Netherlands", dial: "31", flag: "🇳🇱" },
  { code: "BE", name: "Belgium", dial: "32", flag: "🇧🇪" },
  { code: "CH", name: "Switzerland", dial: "41", flag: "🇨🇭" },
  { code: "SE", name: "Sweden", dial: "46", flag: "🇸🇪" },
  { code: "NO", name: "Norway", dial: "47", flag: "🇳🇴" },
  { code: "DK", name: "Denmark", dial: "45", flag: "🇩🇰" },
  { code: "PL", name: "Poland", dial: "48", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", dial: "351", flag: "🇵🇹" },

  // Americas
  { code: "US", name: "United States", dial: "1", flag: "🇺🇸" },
  { code: "CA", name: "Canada", dial: "1", flag: "🇨🇦" },
  { code: "MX", name: "Mexico", dial: "52", flag: "🇲🇽" },
  { code: "BR", name: "Brazil", dial: "55", flag: "🇧🇷" },
  { code: "AR", name: "Argentina", dial: "54", flag: "🇦🇷" },
  { code: "JM", name: "Jamaica", dial: "1876", flag: "🇯🇲" },

  // Asia & Oceania
  { code: "IN", name: "India", dial: "91", flag: "🇮🇳" },
  { code: "CN", name: "China", dial: "86", flag: "🇨🇳" },
  { code: "JP", name: "Japan", dial: "81", flag: "🇯🇵" },
  { code: "KR", name: "South Korea", dial: "82", flag: "🇰🇷" },
  { code: "SG", name: "Singapore", dial: "65", flag: "🇸🇬" },
  { code: "MY", name: "Malaysia", dial: "60", flag: "🇲🇾" },
  { code: "ID", name: "Indonesia", dial: "62", flag: "🇮🇩" },
  { code: "PH", name: "Philippines", dial: "63", flag: "🇵🇭" },
  { code: "TH", name: "Thailand", dial: "66", flag: "🇹🇭" },
  { code: "VN", name: "Vietnam", dial: "84", flag: "🇻🇳" },
  { code: "AU", name: "Australia", dial: "61", flag: "🇦🇺" },
  { code: "NZ", name: "New Zealand", dial: "64", flag: "🇳🇿" },
];

export const DEFAULT_COUNTRY = "GH";

export const getCountry = (code) =>
  countries.find((c) => c.code === code) || countries.find((c) => c.code === DEFAULT_COUNTRY);

// Compose the display phone string from country + local number.
export const buildFullPhone = (countryCode, local) => {
  const c = getCountry(countryCode);
  const digits = String(local || "").trim();
  if (!digits) return "";
  return `+${c.dial} ${digits}`;
};
